import { render } from "./Skeleton.htm?vue&type=template&id=19f494ec&scoped=true"
import script from "./Skeleton.js?vue&type=script&lang=js"
export * from "./Skeleton.js?vue&type=script&lang=js"

import "./Skeleton.scss?vue&type=style&index=0&id=19f494ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f494ec"]])

export default __exports__